import React from "react";

import { Button } from "@components/General/Button/button.component";

import "./infoBlockHeading.scss";

type InfoBlockHeadingProps = {
    title: string;
    onClick: () => void;
};

const InfoBlockHeading = ({ title, onClick }: InfoBlockHeadingProps) => {
    return (
        <section className="info-block__heading">
            <div className="row">
                <div className="col-12">
                    <Button
                        type="button"
                        className="d-flex flex-row text-left p-0 info-block__heading-button"
                        color="link"
                        fullWidth
                        onClick={onClick}
                    >
                        <div className="flex-grow-1">
                            <h4 className="my-3 d-block">{title}</h4>
                        </div>
                        <div className="heading-4 my-3 d-block">
                            <i className="las la-plus"></i>
                            <i className="las la-minus"></i>
                        </div>
                    </Button>
                </div>
            </div>
        </section>
    );
};

export { InfoBlockHeading };
